import {DataFetcher} from '@aboutyou/data-fetcher';
import React from 'react';
import {useCanShowCoupons} from '../../../features/Coupons/useCanShowCoupons';
import {usePriceAndBrandSection} from '../useGetProductBulkSection';
import {PriceAndBrandLoading} from './PriceAndBrandLoading';
import {PriceAndBrandView, PriceAndBrandViewProps} from './PriceAndBrandView';
import {useComputeDefaultState} from './utils';

export const PriceAndBrand: React.FC<PriceAndBrandViewProps> = props => {
  const defaultState = useComputeDefaultState();
  const canShowCoupons = useCanShowCoupons();

  return (
    <DataFetcher
      request={usePriceAndBrandSection()}
      Error={null}
      Loading={() => <PriceAndBrandLoading className={props.className} />}
      View={viewProps => (
        <PriceAndBrandView {...viewProps} isInMiniADPDialog={false} />
      )}
      viewProps={{
        ...props,
        showActiveCouponBadge: props.showActiveCouponBadge && canShowCoupons,
      }}
      computeDefaultState={() => defaultState}
    />
  );
};
